import React, { useEffect, useState } from 'react';
// import { Link } from 'react-router-dom';
import '../pages/ProjectDetails.css';
import ProjectHeader from './ProjectHeader';
import Footer from './Footer';

export default function ProjectTemplate({ project, contactHref = '#contact' }) {
  const [theme, setTheme] = useState(() => {
    try {
      const stored = localStorage.getItem('siju-theme');
      if (stored === 'light' || stored === 'dark') return stored;
      const prefersLight = window.matchMedia && window.matchMedia('(prefers-color-scheme: light)').matches;
      return prefersLight ? 'light' : 'dark';
    } catch (e) {
      return 'dark';
    }
  });
  // eslint-disable-next-line no-unused-vars
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    try { localStorage.setItem('siju-theme', theme); } catch (e) { }
  }, [theme]);

  // eslint-disable-next-line no-unused-vars
  function toggleTheme() { setTheme((t) => (t === 'dark' ? 'light' : 'dark')); }

  return (
    <div className={`hp-root ${theme === 'light' ? 'light' : ''}`} data-theme={theme}>
      <ProjectHeader />

      <main>
        <section className="hp-hero">
          <div className="hp-hero-content">
            <h1>{project.title}</h1>
            <p className="hp-lead muted">{project.summary}</p>
            {/* hero actions removed - contact button moved to end of features */}
          </div>

          <div className="hp-hero-visual">
            <div className="card">
              <img src={project.hero} alt={project.title} style={{ width: '100%', borderRadius: 12 }} />
            </div>
          </div>
        </section>

        <section className="hp-section">
          <h2>Project details</h2>
                <div className="project-details">
                  {project.details.split(/\n\s*\n/).map((para, i) =>
                    <p key={i}>{para.trim()}</p>
                  )}

                  {/* Available In section */}
                  {project.availableIn && project.availableIn.length > 0 && (
                    <div className="available-in">
                      <h2>Available In</h2>
                      <div className="badges">
                        {['desktop','android','web'].map((p) => (
                          project.availableIn.includes(p) ? (
                            <span key={p} className="badge">{p.charAt(0).toUpperCase() + p.slice(1)}</span>
                          ) : null
                        ))}
                      </div>
                    </div>
                  )}
          </div>
          {project.features && (
            <>
              <div className="feature-list" style={{ marginTop: 16 }}>
                {project.features.map((f, idx) => {
                  const isOdd = idx % 2 === 0; // index 0 => feature #1 (odd)
                  return (
                    <div className={`feature-item ${isOdd ? 'odd' : 'even'}`} key={f.id}>
                      <div className="feature-media">
                        <img src={f.img} alt={f.title} />
                      </div>
                      <div className="feature-body">
                        <h4>{f.title}</h4>
                        <p className="muted">{f.desc}</p>
                      </div>
                    </div>
                  );
                })}
              </div>

              <div style={{ marginTop: 20 }}>
                {project.demoUrl && project.demoUrl !== '#' ? (
                  <a
                    className="btn primary"
                    href={project.demoUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    View Demo
                  </a>
                ) : (
                  <button
                    className="btn primary"
                    type="button"
                    onClick={(e) => e.preventDefault()}
                  >
                    Call for details
                  </button>
                )}
              </div>
            </>
          )}
        </section>
      </main>

      <Footer />
    </div>
  );
}
